<template>
    <div class="content">
        <h2> Choose your player and go live 🚀</h2>
        <div class="md-layout">
            <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
                <md-steppers>
                    <md-step id="first" md-label="Clapper">
                        <strong>Demo: <a href="https://swarm.video/clappr.html" target="_blank">clappr.io</a></strong>
                        <div class="well">
                          <clappr></clappr>
                        </div>
                    </md-step>


                    <md-step id="second" md-label="JW Video">
                        <strong>Demo: <a href="https://swarm.video/jwplayer.html"
                                                  target="_blank">jwplayer.com</a></strong>
                        <div class="well">
                            <jwvideo></jwvideo>
                        </div>
                    </md-step>

                    <md-step id="third" md-label="Plyr">
                        <strong>Demo: <a href="https://swarm.video/plyr.html" target="_blank">plyr.io</a></strong>

                        <div class="well">
                            <plyr></plyr>
                        </div>
                    </md-step>


                    <md-step id="fourth" md-label="VideoJs">
                        <strong>Demo: <a href="https://swarm.video/videojs.html/" target="_blank">videojs.com</a></strong>
                        <div class="well">
                            <videojs></videojs>
                        </div>
                    </md-step>
                    <md-step id="fifth" md-label="flowplayer">
                        <strong>Demo: <a href="https://swarm.video/flowplayer.html" target="_blank">flowplayer.com</a></strong>
                        <div class="well">
                            <flowplayer></flowplayer>
                        </div>
                    </md-step>
                </md-steppers>
            </div>
        </div>


   
<div class="md-layout">
<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
        <stats-card data-background-color="blue">
          <template slot="header">
            <md-icon>sync</md-icon>
          </template>

          <template slot="content">
            <h3><strong>httpUseRanges</strong></h3>
            <span>
              Http ranges requests to Allows to continue (and not start over) aborted P2P downloads over HTTP
            </span>
          </template>
          <template slot="footer">
            <div>
                
             <div class="md-layout-item md-medium-size-50 md-xsmall-size-50 md-size-50">        
                   <md-card>
  
            <md-card-expand>
                <md-card-actions>
                    <md-card-expand-trigger>
                    <md-button> Nginx Config </md-button>
                    </md-card-expand-trigger>
                </md-card-actions>
                <md-card-expand-content>
<div class="well">
add_header 'Access-Control-Expose-Headers' 'Content-Length,Content-Range';<br>
add_header 'Access-Control-Allow-Headers' 'Range';<br>
# allow CORS preflight requests<br>
if ($request_method = 'OPTIONS') {<br>
&nbsp;&nbsp;&nbsp;&nbsp;add_header 'Access-Control-Allow-Origin' '*';<br>
&nbsp;&nbsp;&nbsp;&nbsp;add_header 'Access-Control-Allow-Headers' 'Range';<br>
&nbsp;&nbsp;&nbsp;&nbsp;add_header 'Access-Control-Max-Age' 1728000;<br>
&nbsp;&nbsp;&nbsp;&nbsp;add_header 'Content-Type' 'text/plain charset=UTF-8';<br>
&nbsp;&nbsp;&nbsp;&nbsp;add_header 'Content-Length' 0;<br>
&nbsp;&nbsp;&nbsp;&nbsp;return 204;<br>
}
</div>
                </md-card-expand-content>
            </md-card-expand>
    </md-card>

             </div>

<div class="md-layout-item md-medium-size-50 md-xsmall-size-50 md-size-50">          
      <md-card>

   <md-card-expand>
                <md-card-actions>
                    <md-card-expand-trigger>
                      <md-button>Nimble Config </md-button>
                    </md-card-expand-trigger>
                </md-card-actions>
                <md-card-expand-content>
                      <div class="well">
                      Open your config file (Usually located at /etc/nimble/nimble.conf).<br>
                      Add the following lines at the bottom of the file:<br><br>
        access_control_allow_origin = *<br>
        access_control_expose_headers = Content-Length<br>
        access_control_allow_headers = Range<br><br>
        save the file<br>
        Restart the nimble service using this command: sudo service nimble restart<br>
                      </div>
                </md-card-expand-content>
            </md-card-expand>
    </md-card>

</div>
                </div>
          </template>
        </stats-card>
      </div>







<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
        <stats-card data-background-color="blue">
          <template slot="header">
            <md-icon>mediation</md-icon>
          </template>

          <template slot="content">
            <h3 class="title"><strong>WaitForTracker</strong> & <strong>WaitForTrackerCounter</strong></h3>
            <span>
                Download initial segments over P2P http will be forcibly enabled if there is no peers on tracker or WaitForTrackerCounter is timed out
            </span>
            
          </template>
          <template slot="footer">
            <span>
                Giving the Peers extra miliseconds to download initial segments will increace the p2p Rateo
            </span>
          </template>
        </stats-card>
</div>





<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
        <stats-card data-background-color="blue">
          <template slot="header">
            <md-icon>all_inclusive</md-icon>
          </template>

          <template slot="content">
            <h3 class="title"><strong>swarmId</strong></h3>
            <span>
                Select a custom name for each Stream to Group different edges into the same swarm name
            </span>
            
          </template>
          <template slot="footer">
            <span>
                That may you scale your backend without affect the p2p ratio
            </span>
          </template>
        </stats-card>
</div>
</div>




    </div>


</template>

<script>
import {Clappr,
        Jwvideo,
        Plyr,
        Videojs,
        Flowplayer} from "@/examples";
import {StatsCard,} from "@/components";

export default {
    components: {
        StatsCard,
        Clappr,
        Plyr,
        Jwvideo,
        Videojs,
        Flowplayer
        
    }
}
</script>
<style scoped>
h2 { text-align: center;}
</style>